import React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Combo, PopupAnchor, SourceAnchor} from '@mintdata-wsp/common/components/combo/Combo';
import {UserIconSize} from './UserIcon';
import {IListItemState, ListModel} from '@mintdata-wsp/mint-kit/api/models/List';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {bind} from 'bind-decorator';
import {UserIconPopupCard} from './UserIconPopupCard';
import {ActiveUserEvent} from '@mintdata-wsp/wsp/controllers/multiplayer/MultiplayerController';
import {IStyles} from '@mintdata-wsp/mint-kit/impl/util/Styles';
import {PopupSize} from '@mintdata-wsp/mint-kit/impl/components/popover/PopupTypes';
import {action} from 'mobx';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

interface UserPlusIconProps
{
    iconSize:UserIconSize;
    count:number;
    wspMode?:boolean;
}

const styles = require('./UserIcon.less');
const cx = classnames.bind(styles);

@observer
export class UserPlusIcon extends React.Component<UserPlusIconProps>
{
    public render():JSX.Element
    {
        const {iconSize} = this.props;

        const {activeUsers} = rootState.ui.visualDesigner;

        if( !activeUsers.otherUsers || !activeUsers.otherUsers.length )
            return null;

        const users = activeUsers.otherUsers;

        const listModel = new ListModel(users);
        listModel.selectFirstItem();

        return <div
            className={cx('userIconContainer', iconSize)}
        >
            <Combo key={'combo'}
                className={cx('combo')}
                theme={{
                    content: cx('comboContent'),
                    listView: cx('comboListView')
                }}
                dataSource={listModel}
                contentRenderer={this._renderUserPlusIcon}
                itemRenderer={this._itemsRenderer}
                onSelectItem={(user:ActiveUserEvent) => this._handleUserIconClick(user.userId)}
                sourceAnchor={SourceAnchor.LeftBottom}
                popoverAnchor={PopupAnchor.LeftTop}
                popupSize={PopupSize.Original}
            >
                <header>
                    <div className={cx('userIconListHeader')}>{`${users.length} users`}</div>
                </header>
            </Combo>
        </div>
    }

    @bind
    private _renderUserPlusIcon()
    {
        const {iconSize, count} = this.props;

        const label = `+${count}`;
        return <div className={cx('userPlusIconColor', 'plusIcon', iconSize)}>
            <Row className={cx('userIcon', iconSize)}>
                {label}
            </Row>
        </div>
    }

    _itemsRenderer(data:ActiveUserEvent, state:IListItemState, styles:IStyles):JSX.Element
    {
        return <UserIconPopupCard key={data.userId} user={data} />;
    }

    @action.bound
    _handleUserIconClick(userId:number)
    {
        if( this.props.wspMode )
            return;

        const {activeUsers} = rootState.ui.visualDesigner;
        const {activeUsersSync} = controllers.ui;

        if( activeUsers.followingUserId === userId )
        {
            activeUsersSync.stopFollowing();
        }
        else
        {
            activeUsers.followingUserId = userId;
            activeUsersSync.updateFollowingState();
        }
    }

}